import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .user_avatar {
    position: relative;
    width: 24px;
    height: 24px;
  }
  .avatar_image.thirtytwo {
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }
  .avatar_image.thirtytwo.bc:before {
    display: flex;
    position: absolute;
    content: '';
    left: -1px;
    bottom: -1px;
    align-items: center;
    justify-content: center;
    background: hsla(0, 0%, 0%, 0.7) url(${icons.clone_bid_icon}) center center / auto 8px no-repeat;
    backdrop-filter: blur(20px);
    width: 8px;
    height: 8px;
    padding: 4px;
    border-radius: 0 7px 0 7px;
  }
  .content {
    height: calc(100% + 15px);
    height: 100%;
    transition: width 300ms ease-in-out;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 0 0 0 0;
    overflow: hidden;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/user-account.css */
  .content {
    width: 100%;
    align-items: flex-start;
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    padding: 30px 0 0 0;
    overflow: visible;
  }
  .content.column {
    width: 100%;
    align-items: center;
    padding: 30px 0 0 0;
    border-top: 0;
  }
  #user-bc_panel .content.column {
    align-items: flex-start;
  }
  .subtitle {
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    margin: 0 0 14px 30px;
  }
  .content.column .subtitle {
    margin: 0 0 14px 0;
    display: flex;
    align-items: center;
  }
  .content.column .subtitle.alt {
    margin: 0 0 14px 0;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .content.column .subtitle .total_fees_earned {
    font-size: 0.8rem;
    text-transform: none;
    padding: 5px 0 0 0;
  }
  .content.column .subtitle .total_fees_earned strong {
    font-weight: 600;
  }

  .content.column form {
    width: 100%;
  }
  .content.column form label {
    font-size: 0.75rem;
    opacity: 0.7;
  }
  .content.column fieldset {
    margin: 5px 0 0 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    border-radius: 10px;
  }
  .content.column fieldset input.clone_bid_max-amount {
    background: hsl(231, 5%, 30%);
    padding: 6px 14px;
    width: 100%;
    border-radius: 7px 0 0 7px;
    max-width: 200px;
  }
  .content.column fieldset input.clone_bid_max-amount::placeholder {
    color: #fff;
  }
  .content.column fieldset button.save {
    padding: 6px 10px 5px 10px;
    font-size: 0.8rem;
    border-radius: 0 7px 7px 0;
    white-space: nowrap;
  }
  .grid-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-content label {
    padding: 0 0 10px 0;
    line-height: 130%;
    display: flex;
    align-items: center;
  }
  .grid-content label.title {
    text-align: right;
    text-transform: uppercase;
    font-size: 0.85rem;
    justify-content: flex-end;
    max-width: 300px;
  }
  .grid-content label.value {
    margin: 0 0 0 15px;
    font-weight: 700;
    font-size: 0.8rem;
    justify-content: flex-start;
  }
  .grid-content.bid_cloning_list {
    grid-template-columns: 1fr 1fr;
    width: 90%;
    margin: 0;
  }
  .grid-content.bid_cloning_list label.title {
    text-align: left;
    justify-content: flex-start;
    max-width: auto;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
    text-transform: none;
    padding: 10px 0;
  }
  .grid-content.bid_cloning_list .bid_cloning_table_row:last-child label.title,
  .grid-content.bid_cloning_list .bid_cloning_table_row:last-child label.value {
    border-bottom: 0;
  }
  .grid-content.bid_cloning_list label.title .user_name {
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    font-weight: 600;
  }
  .grid-content.bid_cloning_list label.title .user_name .user_subline {
    font-size: 0.65rem;
    padding: 3px 0 0 0;
    display: inline;
  }
  .grid-content.bid_cloning_list label.title .user_name .user_subline strong {
    font-weight: 600;
    display: inline;
  }
  .grid-content.bid_cloning_list label.value {
    margin: 0;
    justify-content: flex-end;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
    padding: 10px 0;
  }
  .grid-content.bid_cloning_list .bid_cloning_table_row {
    display: contents;
  }
  #user-bc_panel {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 550px;
    min-height: 350px;
    width: calc(100% - 30px);
    padding: 0 30px 0 0;
    margin: 0 -30px 0 30px;
  }
  #user-bc_panel .bc_panels_column {
    display: flex;
    flex-direction: row;
  }
  button.remove_icon {
    background: url(${icons.remove_icon}) center center / 16px auto no-repeat;
    background-color: transparent;
    width: 16px;
    height: 16px;
    display: block;
  }
  .grid-content.bid_cloning_list .user_avatar {
    margin: 0 8px 0 0;
    width: 32px;
    height: 32px;
  }
`

const developerCSS = css`
  #user-bc_panel {
    width: 100%;
    padding: 0;
    margin: 0;
  }
`

export const BidCloningCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
